var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4212 41C30.1011 41 28.8663 40.762 27.7166 40.2861C26.5669 39.8102 25.5662 39.1072 24.7146 38.177C23.8842 37.2468 23.2242 36.1003 22.7345 34.7375C22.2448 33.3746 22 31.8171 22 30.0649C22 28.3343 22.2448 26.7876 22.7345 25.4248C23.2455 24.0403 23.9268 22.8722 24.7784 21.9204C25.6514 20.9685 26.6627 20.2439 27.8124 19.7463C28.9834 19.2488 30.2289 19 31.5489 19C32.8689 19 34.0399 19.2704 35.0619 19.8112C36.0838 20.352 36.9248 20.9794 37.5848 21.6932L35.6048 24.1268C35.0512 23.5644 34.4551 23.1209 33.8164 22.7965C33.1776 22.4503 32.4538 22.2773 31.6447 22.2773C30.7931 22.2773 30.0053 22.4612 29.2814 22.8289C28.5788 23.175 27.9614 23.6834 27.4291 24.354C26.9182 25.0029 26.5136 25.8033 26.2156 26.7552C25.9388 27.707 25.8004 28.7778 25.8004 29.9676C25.8004 32.3904 26.3114 34.294 27.3333 35.6785C28.3766 37.0413 29.7818 37.7227 31.5489 37.7227C32.4857 37.7227 33.316 37.528 34.0399 37.1386C34.7638 36.7276 35.4238 36.1976 36.02 35.5487L38 37.9174C37.1484 38.9125 36.169 39.6804 35.0619 40.2212C33.976 40.7404 32.7625 41 31.4212 41Z",
    fill: "#2300F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgC);
export default __webpack_public_path__ + "static/media/img C.cc4594fcbd00096adf13be7b13c24584.svg";
export { ForwardRef as ReactComponent };